import Vue from 'vue'
import VueRouter from 'vue-router'
import FlightResults from '../views/flightResults.vue'
import Login from '../views/login.vue'
// import SignUp from '../views/SignUp.vue'
import Home from '../views/Home.vue'
// import store from '@/store'
// import VerifyEmail from '../views/VerifyEmail.vue'
import Book from '../views/book.vue'
import ChangePassword from '../views/changePassword.vue'
import Profile from '../views/Profile.vue'
Vue.use(VueRouter)

const routes = [
  {
    name: 'home',
    path: '/',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    name: 'profile',
    path: '/profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  { path: '/flightResult', component: FlightResults, meta: { requiresAuth: true }, name: 'flightResults' },
  { path: '/login', component: Login, meta: { requiresAuth: false }, name: 'login' },
  // { path: '/register', component: SignUp, meta: { guestOnly: true } },
  // { path: '/verify', component: VerifyEmail, meta: { guestOnly: true } },
  { path: '/change-password', component: ChangePassword },
  {
    name: 'book',
    path: '/book/:id/:search/:relatedFlightId',
    component: Book,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history', // or 'hash'
  routes
})

router.beforeEach((to, from, next) => {
  // const isLoggedIn = !!store.state.user
  const isLoggedIn = localStorage.getItem('TKtoken')
  if (to.meta.requiresAuth && !isLoggedIn) {
    next({
      name: 'login',
      query: {
        redirect: to.fullPath
      }
    })
  } else {
    next()
  }
  // if (to.meta.requiresAuth && !isLoggedIn) {
  //   next('/login')
  // } else if (to.meta.guestOnly && isLoggedIn) {
  //   next('/')
  // } else {
  //   next()
  // }
})
export default router
